module.exports = __webpack_public_path__ + "static/img/bg_xiadan.5a93ed72.png";